import React from 'react';
import styles from "./Accordion.module.scss"
import Image from 'next/image';

import { FiPlus } from "react-icons/fi";
import { FiMinus } from "react-icons/fi";


const Accordion = ({ title, content, index, activeIndex, setActiveIndex }) => {
  const isActive = index === activeIndex;

  const handleClick = () => {
    setActiveIndex(isActive ? null : index);
  };

  return (
    <div className={styles.accordion_item}>
      <div className={styles.accordion_title} onClick={handleClick}>
        <h5>{title}</h5>
        <div>{isActive ? <FiMinus /> : <FiPlus />}</div>
      </div>
      {isActive && <p className={styles.accordion_content}>{content}</p>}
    </div>
  );
};

export default Accordion;